import { jsxs, jsx } from "react/jsx-runtime";
import { useMutationState } from "@contember/binding";
import { useClassName } from "@contember/react-utils";
import { Button, Text } from "@contember/ui";
import { PlusCircleIcon } from "lucide-react";
import { memo } from "react";
const CreateNewEntityButton = memo(
  ({ createNewEntity, iconProps, children = "Add", ...buttonProps }) => {
    const isMutating = useMutationState();
    return /* @__PURE__ */ jsxs(
      Button,
      {
        onClick: () => createNewEntity(),
        disabled: isMutating,
        loading: isMutating,
        className: useClassName("new-entity-button"),
        distinction: "seamless",
        justify: "start",
        padding: "gap",
        ...buttonProps,
        children: [
          /* @__PURE__ */ jsx(PlusCircleIcon, {}),
          typeof children === "string" || typeof children === "number" ? /* @__PURE__ */ jsx(Text, { children }) : children
        ]
      }
    );
  }
);
export {
  CreateNewEntityButton
};
//# sourceMappingURL=CreateNewEntityButton.js.map
